import { render, staticRenderFns } from "./GoogleText.vue?vue&type=template&id=381adbc0&"
import script from "./GoogleText.vue?vue&type=script&lang=js&"
export * from "./GoogleText.vue?vue&type=script&lang=js&"
import style0 from "./GoogleText.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports